import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useState, useRef } from "react";
import { useGetTrainingUrlQuery } from '../../api/ducApiSlice';
import { useUserInfoQuery } from "../../api/userApiSlice";
import { TrainingProcessSteps } from "./TrainingProcess";

const TrainingMaterial = ({ setCurStep }: any) => {
    // @ts-ignore
    const trainingUrlEnv = window.env.trainingUrl
    const hasSetUrl = useRef(false);
    const { data: userData } = useUserInfoQuery({}, {
        // Use more conservative caching options to prevent infinite loops
        pollingInterval: 0, // Disable polling
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });
    const username = userData?.username;
    const { data: trainingUrl } = useGetTrainingUrlQuery({ username }, {
        skip: !username, // Skip if username is not available
        // Use more conservative caching options
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });
    const [url, setUrl] = useState("")


    useEffect(() => {
        // Only set the URL once to prevent unnecessary re-renders
        if (!hasSetUrl.current) {
            if(typeof trainingUrl === "string"){
                setUrl(trainingUrl);
            } else {
                setUrl(trainingUrlEnv);
            }
            hasSetUrl.current = true;
        }
    }, [trainingUrl, trainingUrlEnv]);


    const handleClick = () => {
        setCurStep(TrainingProcessSteps.Assessment);
        window.open(url,"_blank");
    }


    return (
        <Stack alignItems="center" gap={3} marginTop="100px">
            <Box maxWidth="800px">
                <Typography textAlign="center">As an NBDC Data Hub user, you must complete the Responsible Data and Biospecimen Use Training.
                    Please review the following materials which outline key principles and expectations for responsible use. A short quiz at the end will assess your understanding. Please note that you must achieve at least 90% accuracy to pass. You will then be given access to the NBDC data.
                </Typography>
            </Box>

            <Stack alignItems="center" maxWidth="800px" gap={3}>
                <Button
                    variant="primary"
                    onClick={handleClick}
                >
                    Continue
                </Button>
            </Stack>

        </Stack>


    )
}

export default TrainingMaterial
